// filepath: /Users/chris/repo/theobp-site/src/pages/events/SuperBowlApplicationPage.tsx
import React from 'react';

const SuperBowlApplicationPage: React.FC = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="iframe-header success">
            <h1>Super Bowl Application Info</h1>
            <p className="lead mb-0">Host City TBD • February 2026</p>
          </div>
          
          <div className="iframe-container">
            <iframe
              src="https://www.attendtheobp.com/super-bowl-app.html"
              width="100%"
              height="800"
              frameBorder="0"
              title="Super Bowl Application Information"
              style={{
                minHeight: '800px',
                border: 'none'
              }}
            />
          </div>
          
          <div className="iframe-footer">
            <div className="text-center">
              <p className="text-muted mb-0">
                <a href="/" className="text-decoration-none">← Back to Home</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperBowlApplicationPage;
